var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mem-chart"},[_c('svg',{staticClass:"mem-chart__svg"})])}
var staticRenderFns = []

export { render, staticRenderFns }